// extracted by mini-css-extract-plugin
export default {"root":"LlGZPF","arrowContainer":"xF3dsS","left":"Y1HhPf","right":"_8Ct51S","arrowButton":"KKmXu2","chevron":"h2zwRS"};